/**
 * Route definitions for the Timesheets module.
 * Lazily loads the main timesheets page with activities, overtime rules, pay periods, and daily timecard tabs.
 */
import createFeatureRoutes from '@/common/presentation/components/MainRouteHelper/MainRouteHelper';

const TimesheetsRoutes = createFeatureRoutes(
  'timesheets',
  {
    list: () => import('../presentation/pages')
  },
  [{ path: '', pageKey: 'list' }]
);

export default TimesheetsRoutes;
